
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { User, Edit2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProfileBioHeaderProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  freelancerId?: string | null;
}

export const ProfileBioHeader = ({ isEditing, setIsEditing, freelancerId }: ProfileBioHeaderProps) => {
  return (
    <div className="pb-2 flex flex-row items-center justify-between">
      <CardTitle className="text-xl flex items-center gap-2">
        <User className="w-5 h-5 text-emerald-500" />
        Professional Bio
      </CardTitle>
      {!isEditing && !freelancerId && (
        <Button variant="ghost" size="sm" onClick={() => setIsEditing(true)}>
          <Edit2 className="w-4 h-4" />
        </Button>
      )}
    </div>
  );
};
